// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3d20a","header":"styles_header__3rhg6","button":"styles_button__3DA-A","cancel":"styles_cancel__2xI5t"};